<template>
    <div class="form-element__container" :id="fullFormIdentifier + '-container'">
        <input
            v-if="inputType == 'number'"
            :id="fullFormIdentifier"
            v-model="internalValue"
            :class="{ 'form-element__input--active': isFilled }"
            class="form-element__input"
            type="text"
            :name="inputName"
            :data-validate="validation"
            :data-validate-message="validationMessage"
            :data-error-target="fullFormIdentifier + '-container'"
            autocomplete="off"
            :min="min"
            :max="max"
            :step="step"
            v-on:blur="cleanseNumber"
        />
        <input
            v-else
            :id="fullFormIdentifier"
            v-model="internalValue"
            :class="{ 'form-element__input--active': isFilled }"
            class="form-element__input"
            :type="inputType"
            :name="inputName"
            :data-validate="validation"
            :data-validate-message="validationMessage"
            :data-error-target="fullFormIdentifier + '-container'"
            autocomplete="off"
        />
        <label :for="fullFormIdentifier" class="form-element__label" :class="{ 'form-element__label--hidden': isFilled }">{{ inputTitle }}</label>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                default: null,
                required: true,
            },
            formIdentifier: {
                type: String,
                default: "form",
            },
            inputType: {
                type: String,
                default: "text",
            },
            inputName: {
                type: String,
                default: "",
            },
            inputTitle: {
                type: String,
                required: true,
            },
            inputValidate: {},
            inputValidateMessage: {
                type: String,
                default: "",
            },
            min: {
                default: null,
            },
            max: {
                default: null,
            },
            step: {
                default: null,
            },
            integerOnly: {
                default: false,
            }
        },
        data() {
            return {
                everModified: false,
                internalValue: null,
            };
        },
        created() {
            this.internalValue = this.value;
        },
        watch: {
            internalValue: function(newValue) {
                // if (this.inputType != 'number') {
                //     this.$emit('input', newValue);
                //     return;
                // }

                // this.internalValue = parseFloat(newValue);
                // if (this.step != null && this.internalValue % this.step) {
                //     this.internalValue = Math.round(this.internalValue / this.step) * this.step;
                // }
                // if (this.max != null && this.internalValue > this.max) {
                //     this.internalValue = this.max;
                // }
                // if (this.min != null && this.internalValue < this.min) {
                //     this.internalValue = this.min;
                // }
                this.$emit('input', newValue);
            },
            value: function(newValue) {
                this.internalValue = newValue;
            }
        },
        methods: {
            cleanseNumber() {
                this.everModified = true;
                this.internalValue = parseFloat(this.internalValue);
                if (this.step != null && this.internalValue % this.step) {
                    this.internalValue = Math.round(this.internalValue / this.step) * this.step;
                }
                if (this.max != null && this.internalValue > this.max) {
                    this.internalValue = this.max;
                }
                if (this.min != null && this.internalValue < this.min) {
                    this.internalValue = this.min;
                }
                if (isNaN(this.internalValue)) {
                    this.internalValue = null;
                }
                return this.internalValue;
            },
        },
        computed: {
            isFilled() {
                if (this.internalValue == null) {
                    return false;
                }

                if (this.inputType == "number") {
                    return !isNaN(this.internalValue);
                }

                if (this.internalValue == '') {
                    return false;
                }

                return true;
            },
            validation() {
                if (this.inputValidate == 'number') {
                    return "number";
                }
                if (this.inputValidate) {
                    return "input";
                }
                return false;
            },
            validationMessage() {
                if (this.inputValidateMessage) {
                    return this.inputValidateMessage;
                }
                return false;
            },
            fullFormIdentifier() {
                return this.formIdentifier + "-" + this._uid;
            },
        },
    };
</script>